import { Observable, map, tap } from "rxjs";
import { Apollo, TypedDocumentNode } from "apollo-angular";
import { Mapper } from '../mappers/mapper';
import log from "loglevel";
import { ApolloQueryResult } from "@apollo/client/core";
import { SnackbarService } from "../../snackbar-service/snackbar.service";


export interface BaseQueryData<T> {
  items: T[];
  pager: {
    current: number | null;
    next: number | null;
    prev: number | null;
  }
  total: number
  _typename?: string
}


//interface BaseQueryResponse<T> {
//  [key: string]: BaseQueryData<T>;
//}


export abstract class BaseRepository<T, DTO> {

  protected logger = log.getLogger('BaseRepository');

  protected abstract _mapper: Mapper<T, DTO>;

  constructor(
    protected apollo: Apollo,
    protected snackBar: SnackbarService
  ) {
  }

  public abstract getGqlQuery(): TypedDocumentNode<unknown, unknown>;

  protected abstract dataPropertyName: string;

  //public retrieveOne(): Observable<T> {
  //  return this.fetchOne().pipe(
  //    //map(item => console.log(item)),
  //    map(item => this._mapper.mapToEntity(item))
  //  )
  //}

  public retrieveAll<F>(filters?: F): Observable<T[]> {
    return this.fetchAll<F>(filters).pipe(
      tap(items => this.logger.debug(`Fetched ${items.length} items from ${this.constructor.name}`)),
      tap(items => this.logger.trace('Fetched items: ', items)),
      map(items => this._mapper.mapToEntities(items)),
      tap(items => this.logger.debug(`Converted ${items.length} items to entities`)),
      tap(items => this.logger.trace('Items converted to entities: ', items)),
    )
  }

  //public fetchOne(): Observable<DTO> {
  //  return this.apollo.watchQuery({
  //    query: this.getGqlQuery(),
  //  })
  //    .valueChanges
  //    .pipe(
  //      //map((response: any) => console.log(response.data[this.dataPropertyName][this.dataPropertuNameEntity || ''])),
  //      map((response: any) => response.data[this.dataPropertyName][this.dataPropertuNameEntity || ''] as DTO)
  //    )
  //}

  protected fetchAll<F>(filters?: F): Observable<DTO[]> {

    return this.apollo.watchQuery({
      query: this.getGqlQuery(),
      variables: {
        ...filters
      }
    })
      .valueChanges
      .pipe(
        map((response: ApolloQueryResult<unknown>) => {
          const data = response.data as Record<string, BaseQueryData<DTO>>;
          return data[this.dataPropertyName].items;
        }),
      );
  }
}
